import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-1.5 px-1.5 py-2.5 md:px-3 md:py-5 bg-[linear-gradient(176deg,#eeaf48,#e57221)] mt-3 rounded-tl-2xl rounded-bl-2xl" }
const _hoisted_2 = ["title", "onClick"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = ["href", "title"]
const _hoisted_5 = ["src", "alt"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (menu) => {
      return _withDirectives((_openBlock(), _createElementBlock("li", {
        key: menu.name
      }, [
        (menu.handle)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              role: "button",
              class: "cursor-pointer hover:underline bg-[linear-gradient(0deg,rgba(255,102,36,1)0%,rgba(255,171,36,1)100%)] rounded-md border border-[#ffbc47] shadow-lg",
              title: menu.name,
              onClick: menu.handle
            }, [
              _createElementVNode("img", {
                src: menu.image,
                alt: menu.name,
                class: "rounded-xl"
              }, null, 8 /* PROPS */, _hoisted_3)
            ], 8 /* PROPS */, _hoisted_2))
          : (menu.href)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: menu.href,
                class: "block hover:underline bg-[linear-gradient(0deg,rgba(255,102,36,1)0%,rgba(255,171,36,1)100%)] rounded-md border border-[#ffbc47] shadow-lg",
                title: menu.name
              }, [
                _createElementVNode("img", {
                  src: menu.image,
                  alt: menu.name,
                  class: "rounded-xl"
                }, null, 8 /* PROPS */, _hoisted_5)
              ], 8 /* PROPS */, _hoisted_4))
            : _createCommentVNode("v-if", true)
      ])), [
        [_vShow, menu.show]
      ])
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}